import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './features/auth/auth-store';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Dialogs from './pages/Dialogs';
import Stories from './pages/Stories';
import Dramas from './pages/Dramas';
import Drills from './pages/Drills';
import Abc from './pages/Abc';
import Chunks from './pages/Chunks';
import Images from './pages/Images';
import News from './pages/News';
import Viva from './pages/Viva';
import Cefr from './pages/Cefr';
import CourseMatrix from './pages/CourseMatrix';
import Phonics from './pages/Phonics';
import Topics from './pages/Topics';
import Qa from './pages/Qa';
import N1 from './pages/N1';
import Numbers from './pages/Numbers';
import Phrases from './pages/Phrases';
import Paremiology from './pages/Paremiology';
import Lexicon from './pages/Lexicon';
import Linguistics from './pages/Linguistics';
import Atlas from './pages/Atlas';
import Metagraph from './pages/Metagraph';
import Financials from './pages/Financials';
import Agents from './pages/Agents';
import Publishing from './pages/Publishing';
import Users from './pages/Users';
import Emails from './pages/Emails';
import Books from './pages/Books';
import Coverage from './pages/Coverage';
import Languages from './pages/Languages';
import Regex from './pages/Regex';
import Campaigns from './pages/Campaigns';
import Transcription from './pages/Transcription';
import TwReadings from './pages/TwReadings';
import AudioCourse from './pages/AudioCourse';

export default function App() {
  const { user, loading, refreshSession } = useAuthStore();

  useEffect(() => {
    refreshSession();
  }, [refreshSession]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-primary">
        <p className="text-zinc-500">Loading...</p>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="dialogs" element={<Dialogs />} />
        <Route path="stories" element={<Stories />} />
        <Route path="dramas" element={<Dramas />} />
        <Route path="images" element={<Images />} />
        <Route path="drills" element={<Drills />} />
        <Route path="abc" element={<Abc />} />
        <Route path="chunks" element={<Chunks />} />
        <Route path="news" element={<News />} />
        <Route path="viva" element={<Viva />} />
        <Route path="cefr" element={<Cefr />} />
        <Route path="cefr/:level" element={<Cefr />} />
        <Route path="course-matrix" element={<CourseMatrix />} />
        <Route path="emails" element={<Emails />} />
        <Route path="books" element={<Books />} />
        <Route path="phonics" element={<Phonics />} />
        <Route path="topics" element={<Topics />} />
        <Route path="qa" element={<Qa />} />
        <Route path="n1" element={<N1 />} />
        <Route path="numbers" element={<Numbers />} />
        <Route path="phrases" element={<Phrases />} />
        <Route path="paremiology" element={<Paremiology />} />
        <Route path="lexicon" element={<Lexicon />} />
        <Route path="linguistics" element={<Linguistics />} />
        <Route path="atlas" element={<Atlas />} />
        <Route path="metagraph" element={<Metagraph />} />
        <Route path="financials" element={<Financials />} />
        <Route path="agents" element={<Agents />} />
        <Route path="coverage" element={<Coverage />} />
        <Route path="languages" element={<Languages />} />
        <Route path="publishing" element={<Publishing />} />
        <Route path="users" element={<Users />} />
        <Route path="regex" element={<Regex />} />
        <Route path="campaigns" element={<Campaigns />} />
        <Route path="transcription" element={<Transcription />} />
        <Route path="tw-readings" element={<TwReadings />} />
        <Route path="audio-course" element={<AudioCourse />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
